module.exports = __webpack_public_path__ + "img/logistics-trajectory-deliver.b203d161.svg";